import CheckmateApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useProcessAllSameCasesMutation = () => {
    return useMutation({
        mutationFn: async () => {
            const response = await _apiClient.processAllSameCases();

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to process all same cases');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
    });
};
